export default __webpack_public_path__ + "2ff0eac134c11cc6d770423c6689ed73.svg";